const getSingleRoleData = state => state?.roles?.roleData
const getJobDetails = state => state?.roles?.singleRoleDetails
const getCorpDetails = state => state?.roles?.corporateDetails
const getRolesList = state => state?.roles?.rolesList
const getJobId = state => state?.roles.jobId
const getCities = state => state?.roles.cities
const getPageNum = state => state?.roles.pageNum
const selectors = {
  getRolesList,
  getSingleRoleData,
  getJobDetails,
  getJobId,
  getCities,
  getCorpDetails,
  getPageNum,
}

export default selectors
